import { render, staticRenderFns } from "./SetPaperStepTwoMultiple.vue?vue&type=template&id=a48bbb00&scoped=true&"
import script from "./SetPaperStepTwoMultiple.vue?vue&type=script&lang=js&"
export * from "./SetPaperStepTwoMultiple.vue?vue&type=script&lang=js&"
import style0 from "./SetPaperStepTwoMultiple.vue?vue&type=style&index=0&id=a48bbb00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48bbb00",
  null
  
)

export default component.exports